export default "__VITE_ASSET__BBLrKIbi__"